import { CADENCE, HEALTH, cadenceOf, daysSince, healthOf, ymd } from "../../lib/domain.js";
import { Segmented } from "./Section.jsx";

/* Health is a clock, and this box shows the reading and the two things that
   can change it: logging a review, or overriding the computation by hand.
   An override says so, and can always be handed back to the clock. */
export function HealthBox({ pg, onSetHealth, onLogMeeting, onCadence, onNotifyReview, mailEnabled }) {
  const h = healthOf(pg);
  const tone = HEALTH[h].tone;
  const c = cadenceOf(pg);
  const days = pg.lastMeetingAt ? daysSince(pg.lastMeetingAt) : null;

  const why = pg.manualHealth
    ? "set by hand"
    : days === null
      ? "no review logged"
      : days +
        "d since last review · " +
        c.label.toLowerCase() +
        " (at risk " + c.atRisk + "d, critical " + c.critical + "d)";

  return (
    <div className={"healthbox " + tone}>
      <div className="now">
        <span className="v">{HEALTH[h].label}</span>
        <span className="why">{why}</span>
      </div>

      <div className="healthrow">
        <Segmented
          tone={tone}
          value={pg.manualHealth}
          onPick={onSetHealth}
          options={Object.keys(HEALTH).map((k) => [k, HEALTH[k].label])}
        />
        {pg.manualHealth && (
          <button className="linkbtn" type="button" onClick={() => onSetHealth(null)}>
            Use automatic
          </button>
        )}
      </div>

      <div className="healthrow">
        <button className="btn btn-sm btn-solid" type="button" onClick={onLogMeeting}>
          Log meeting today
        </button>
        {mailEnabled && (
          <button className="btn btn-sm" type="button" onClick={onNotifyReview}>
            Propose a session
          </button>
        )}
        <Segmented
          value={pg.cadence}
          onPick={onCadence}
          options={Object.keys(CADENCE).map((k) => [k, CADENCE[k].label])}
        />
        {pg.lastMeetingAt && (
          <span className="mono" style={{ fontSize: "11px", color: "var(--ink-faint)" }}>
            last {ymd(new Date(pg.lastMeetingAt))}
          </span>
        )}
      </div>
    </div>
  );
}
